<template>
  <nav class="navbar has-shadow is-fixed-top">
    <div class="navbar-brand">
      <router-link to="/" class="navbar-item">
        <strong>Fooshi</strong><span class="is-size-7">Admin</span>
      </router-link>
      <div
        class="navbar-burger burger"
        @click="toggleNavbar()"
        :class="{ 'is-active': isNavbarActive }"
      >
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>

    <div class="navbar-menu" :class="{ 'is-active': isNavbarActive }">
      <div class="navbar-start">
        <div class="navbar-item">
          <div>
            <strong>{{ $t('app.texts.greetings', { name: user.firstName }) }}</strong>
          </div>
        </div>
      </div>

      <div class="navbar-end" v-if="!loading && isAuthenticated">
        <div class="navbar-item">
          <LanguageSelector />
        </div>
        <div class="navbar-item">
          <button class="button is-light" @click="showSupportModal = true">
            {{ $t('app.buttons.support') }}
          </button>
        </div>
        <div class="navbar-item has-dropdown is-hoverable">
          <div class="navbar-link">{{ user.firstName }}</div>
          <div class="navbar-dropdown is-right">
            <a class="navbar-item" @click="logout()">
              <div>
                <span class="icon is-small">
                  <i class="fa fa-sign-out"></i>
                </span>
                {{ $t('app.buttons.signout') }}
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- Support Modal -->
    <div class="modal" v-bind:class="{'is-active': showSupportModal}">
      <div class="modal-background" @click="showSupportModal = false"></div>
      <div class="modal-content">
        <div class="box">
          <p>{{ $t('app.texts.supportMessage') }}</p>
          <p>{{ $t('app.texts.supportVideoCallPrefix') }} <a href="https://calendar.app.google/uAAoQWTmmVE5sWYe6" target="_blank">{{ $t('app.texts.supportVideoCallLink') }}</a>.</p>
        </div>
      </div>
      <button class="modal-close is-large" aria-label="close" @click="showSupportModal = false"></button>
    </div>
  </nav>
</template>

<script>

import Auth from '@/auth/auth'
import { FooshiApi } from '@/services/fooshiApi.service'
import LanguageSelector from '@/components/LanguageSelector.vue'

export default {
  components: {
    LanguageSelector
  },
  methods: {
    toggleNavbar () {
      this.isNavbarActive = !this.isNavbarActive
    },
    async fetchProfile () {
      const response = await FooshiApi.profile()
      if (response.success) {
        const profile = response.data
        this.user.firstName = profile.details.name
      } else {
        // todo: toast
      }
    },
    logout () {
      Auth.getInstance().logout()
      this.$router.push({ path: '/login' })
    }
  },
  async mounted () {
    await this.fetchProfile()
  },
  data () {
    return {
      isNavbarActive: false,
      loading: false,
      isAuthenticated: true,
      showSupportModal: false,
      user: {
        firstName: ''
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/NavigationBar.vue